export default __webpack_public_path__ + "static/media/26.8dffbed5.jpg";